// extracted by mini-css-extract-plugin
export default {"container":"Column_container__kR-Sh","hidden":"Column_hidden__0PotT","items":"Column_items__TwRhH"};